import { Button, Space, Tag } from "antd";
import { paymentStatus } from "../options";
import dayjs from "dayjs";

export const Columns = ({
  fetchDetail,
  order,
  handleReturnTicket,
  handleExchangeTicket,
}) => [
  {
    title: "狀態",
    dataIndex: "status",
    key: "status",
    render: (text, record) => (
      <>
        <span
          className={`text-white rounded-md px-2 ${
            text == 4
              ? "bg-green-500"
              : text == 64
              ? "bg-SKF-G-002"
              : "bg-red-500"
          }`}
        >
          {paymentStatus.find((item) => item.value == text)?.label}
        </span>
        {record?.enableSwitchPolicy && (
          <div>
            <Tag color="blue" className="mt-2 mb-1">
              換票開放時間
              <p className="text-[12px]">
                {dayjs
                  .unix(record?.switchPolicyStartDateTime)
                  .format("YYYY-MM-DD hh:mm:ss")}
                -
                {dayjs
                  .unix(record?.switchPolicyEndDateTime)
                  .format("YYYY-MM-DD hh:mm:ss")}
              </p>
            </Tag>
          </div>
        )}
        {record?.enableRefundPolicy && (
          <div>
            <Tag color="red">
              退票開放時間
              <p className="text-[12px]">
                {dayjs
                  .unix(record?.refundPolicyStartDateTime)
                  .format("YYYY-MM-DD hh:mm:ss")}
                -
                {dayjs
                  .unix(record?.refundPolicyEndDateTime)
                  .format("YYYY-MM-DD hh:mm:ss")}
              </p>
            </Tag>
          </div>
        )}
      </>
    ),
  },
  {
    title: "票號",
    dataIndex: "id",
    key: "id",
  },
  {
    title: "價格",
    dataIndex: "price",
    key: "price",
  },
  {
    title: "票券名稱",
    dataIndex: "title",
    key: "title",
  },
  {
    title: "參加者",
    dataIndex: "name",
    key: "name",
  },
  {
    title: "Email",
    dataIndex: "email",
    key: "email",
  },
  {
    title: "操作",
    dataIndex: "action",
    key: "action",
    render: (text, record) => (
      <Space>
        <Button
          type="link"
          className="text-left decoration-solid p-0"
          onClick={() => fetchDetail(record)}
        >
          詳情
        </Button>
        {record?.enableRefundPolicy && (
          <Button
            size="small"
            type="primary"
            className="h-auto text-left rounded-lg"
            loading={record?.isReturnBtnLoading}
            onClick={() => {
              handleReturnTicket(record);
            }}
          >
            退票
          </Button>
        )}
        {record?.enableSwitchPolicy && (
          <Button
            size="small"
            type="primary"
            className="h-auto text-left rounded-lg"
            loading={record?.isExchangeBtnLoading}
            onClick={() => {
              handleExchangeTicket(record);
            }}
          >
            換票
          </Button>
        )}
      </Space>
    ),
  },
];

export const Columns_mobile = ({
  fetchDetail,
  order,
  handleReturnTicket,
  handleExchangeTicket,
}) => [
  {
    title: "狀態 | 票號 | 操作",
    dataIndex: "id",
    key: "id",
    render: (text, record) => (
      <>
        <span
          className={`text-white rounded-md px-2 mb-1 ${
            record.status == 4 ? "bg-green-500" : "bg-red-500"
          }`}
        >
          {paymentStatus.find((item) => item.value == record.status)?.label}
        </span>
        <p className="font-semibold">{text}</p>
        {record?.enableSwitchPolicy && (
          <>
            <Tag color="blue" className="mt-2 mb-1">
              換票開放時間
              <p className="text-[12px]">
                {dayjs
                  .unix(record?.switchPolicyStartDateTime)
                  .format("YYYY-MM-DD hh:mm:ss")}
                -
                {dayjs
                  .unix(record?.switchPolicyEndDateTime)
                  .format("YYYY-MM-DD hh:mm:ss")}
              </p>
            </Tag>
          </>
        )}
        {record?.enableRefundPolicy && (
          <>
            <Tag color="red">
              退票開放時間
              <p className="text-[12px]">
                {dayjs
                  .unix(record?.refundPolicyStartDateTime)
                  .format("YYYY-MM-DD hh:mm:ss")}
                -
                {dayjs
                  .unix(record?.refundPolicyEndDateTime)
                  .format("YYYY-MM-DD hh:mm:ss")}
              </p>
            </Tag>
          </>
        )}
        <Space
          align="start"
          direction="horizontal"
          className="w-full mt-2 [&_.ant-space-item]:flex-1"
          gap={2}
        >
          <Button
            type="primary"
            size="small"
            className="h-auto text-left bg-black text-[14px] w-full"
            onClick={() => fetchDetail(record)}
          >
            詳情
          </Button>
          {record?.enableRefundPolicy && (
            <Button
              size="small"
              type="primary"
              className="h-auto text-left text-[14px] w-full"
              loading={record?.isReturnBtnLoading}
              onClick={() => {
                handleReturnTicket(record);
              }}
            >
              退票
            </Button>
          )}
          {record?.enableSwitchPolicy && (
            <Button
              size="small"
              type="primary"
              className="h-auto text-left text-[14px] w-full"
              onClick={() => {
                handleExchangeTicket(record);
              }}
            >
              換票
            </Button>
          )}
        </Space>
      </>
    ),
  },
  // {
  //   title: "操作",
  //   dataIndex: "action",
  //   key: "action",
  //   render: (text, record) => (

  //   ),
  // },
];
